import { PaginateOptions } from './../../../utils/paginate.utils';
import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Injectable, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatSelectModule } from '@angular/material/select';
import { ApiService } from '../../../core/api.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs/internal/Observable';
import {map, startWith} from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-select',
  imports: [ReactiveFormsModule, FormsModule, MatSelectModule, CommonModule, MatFormField,MatAutocompleteModule,AsyncPipe],
  templateUrl: './select.html',
  styleUrl: './select.scss',
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> Select),
      multi:true
    }
  ]
})
export class Select implements ControlValueAccessor{
  @Input() data : any = [];
  @Input() filter: boolean = true;
  search: string = '';
  @Input() filteredData: any[] = [];
  @Input() formControl !: FormControl;
  @Input() errorMessage : string = '';
  @Input() label : string = '';
  @Input() disabled: boolean = false;
  @Input() value: any = null;
  @Output() valueChange = new EventEmitter<any>();
  @Output() selectValue = new EventEmitter<number>();
  myControl = new FormControl('');
  filteredOptions: Observable<string[]>;
  constructor() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.data.filter((option: string) => option.toLowerCase().includes(filterValue));
  }
  onChangeCb?: (value:any) => void;
  onTouchedcb?: () =>void;
  ngOnInit() {
    this.filteredData = this.data;
  }
  ngOnChanges() {
    this.filteredData = this.data;
    this.applyFilter();
  }
  writeValue(event: Event): void {
    this.value = event;
  }
  registerOnChange(value:any): void {
    this.onChangeCb = value;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedcb = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }
  setValue(event:Event){
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChangeCb?.(value);
    this.valueChange.emit(value);
  }
  onSearchChange(value: string) {
    this.search = value;
    this.applyFilter();
  }
  applyFilter() {
    if (!this.filter || !this.search) {
      this.filteredData = this.data;
    } else {
      const searchLower = this.search.toLowerCase();
      this.filteredData = this.data.filter((item: any) => item.label.toLowerCase().includes(searchLower));
    }
  }
  fetch(value:number){
    this.value = value;
    this.valueChange.emit(value);
    this.selectValue.emit(value);
  }
  filterAutoComplete(event:string) {
    // Ahora recibe el nombre del campo como tercer argumento
    // Uso para filtrar opciones por campo
    // (debe llamarse con field.name en el HTML)
    // filterAutoComplete(valor, opciones, field.name)
    const filtro = event.toLowerCase() || '';
    this.filteredData = this.filteredData.filter((t: any) => t.label.toLowerCase().includes(filtro));
  }
  displayLabel(event:any) {
    // Para mat-autocomplete displayWith
    return event && typeof event === 'object' && 'label' in event ? event.label : '';
  }
  selectValueAutoEvent(event: any) {
    // Al seleccionar, asigna el objeto completo al control
    const seleccionado = event.option.value;
    if (seleccionado) {
      this.value = seleccionado;
      this.valueChange.emit(seleccionado);
      this.selectValue.emit(seleccionado);
    }
  }
}
